module.exports = require("./ar-EH.d.ts");